import React, { Component } from 'react'

import { connect } from "react-redux";
import { dataType } from "@/constants/data-type";

import "@/companys/ttl/assets/styles/components/market/market-us.scss";
import '@/assets/styles/commons/_styles.scss'

import DataTable from "@/components/DataTable/DataTable";
import { WS_LANG_KEY } from "@/constants/app";
import { utilsFunction, Converter, Comparator } from "@/helpers/functions";
import { userActions } from '@/actions/user';
import { stockActions } from "@/actions/trading/stock.action";
import { PARAMS as requestParams } from "@/constants/params";
import { ACTION_TYPE } from "@/constants/w-socket";


 class Market_US extends Component {
    constructor(props){
        super(props)
        this.state = {
            data: [],
            columnDefs: [
              {
                headerName: props.language.common_symbol,
                colId: "common_symbol",
                field: "symbol",
                tooltipField: "symbol",
                headerClass: "table-header",
                cellClass: "table-cell",
                dataType: dataType.SYMBOL,
                minWidth: 80,
              },
              {
                headerName: props.language.common_name,
                colId: "common_name",
                field: "stockName",
                tooltipField: "stockName",
                headerClass: "table-header",
                cellClass: "table-cell table-ellipsis",
                dataType: dataType.TEXT,
              },
              {
                headerName: props.language.common_price,
                colId: "common_price",
                field: "price",
                tooltipField: 'price',
                headerClass: "table-header text-end",
                cellClass: "table-cell",
                dataType: dataType.CURRENCY,
                comparator: Comparator.numberComparator,
                minWidth: 60,
              },
              {
                headerName: props.language.common_change,
                colId: "common_change",
                field: "change",
                tooltipField: 'change',
                headerClass: "table-header text-end",
                cellClass: "table-cell text-end",
                bindingColor: true,
                dataType: dataType.PERCENT,
                comparator: Comparator.numberComparator,
              },
              {
                headerName: props.language.common_bid,
                colId: "common_bid",
                field: "bid",
                tooltipField: 'bid',
                headerClass: "table-header text-end",
                cellClass: "table-cell text-end",
                bindingColor: true,
                dataType: dataType.CURRENCY,
                comparator: Comparator.numberComparator,
              },
              {
                headerName: props.language.common_ask,
                colId: "common_ask",
                field: "ask",
                tooltipField: 'ask',
                headerClass: "table-header text-end",
                cellClass: "table-cell text-end",
                bindingColor: true,
                dataType: dataType.CURRENCY,
                comparator: Comparator.numberComparator,
              },
              {
                headerName: props.language.common_volume,
                colId: "common_volume",
                field: "volume",
                tooltipField: 'volume',
                headerClass: "table-header text-end",
                cellClass: "table-cell cell-action",
                dataType: dataType.NUMBER,
                comparator: Comparator.numberComparator,
                minWidth: 70,
              },
              {
                headerName: props.language.common_turnover_rate,
                colId: "common_turnover_rate",
                field: "T/O Rate",
                tooltipField: 'T/O Rate',
                headerClass: "table-header text-end",
                cellClass: "table-cell cell-action",
                dataType: dataType.PERCENT,
                comparator: Comparator.numberComparator,
              },
              {
                headerName: props.language.common_open,
                colId: "common_open",
                field: "Open",
                tooltipField: 'Open',
                headerClass: "table-header text-end",
                cellClass: "table-cell cell-action",
                dataType: dataType.CURRENCY,
                comparator: Comparator.numberComparator,
              },
              {
                headerName: props.language.market_quote_prev_close,
                colId: "common_close",
                field: "Close",
                tooltipField: 'Close',
                headerClass: "table-header text-end",
                cellClass: "table-cell cell-action",
                dataType: dataType.CURRENCY,
                comparator: Comparator.numberComparator,
              },
              {
                headerName: props.language.common_high,
                colId: "common_high",
                field: "High",
                tooltipField: "High",
                headerClass: "table-header text-end",
                cellClass: "table-cell cell-action",
                dataType: dataType.CURRENCY,
                comparator: Comparator.numberComparator
              },
              {
                headerName: props.language.common_low,
                colId: "common_low",
                field: "Low",
                tooltipField: "Low",
                headerClass: "table-header text-end",
                cellClass: "table-cell cell-action",
                dataType: dataType.CURRENCY,
                comparator: Comparator.numberComparator,
              },
              {
                headerName: props.language.common_turnover,
                colId: "common_turnover",
                field: "Turnover",
                tooltipField: "Turnover",
                headerClass: "table-header text-end",
                cellClass: "table-cell cell-action",
                dataType: dataType.CASH,
                comparator: Comparator.numberComparator,
              },
              // {
              //   headerName: props.language.common_today_sales_price,
              //   colId: "common_today_sales_price",
              //   field: "todaysales",
              //   headerClass: "table-header text-end",
              //   cellClass: "table-cell cell-action",
              //   dataType: dataType.CURRENCY,
              //   comparator: Comparator.numberComparator,
              //   minWidth: 90,
              // },
            ].filter(Boolean),
        }
    }
    render() {
    const { language } =this.props
    const { columnDefs, data } = this.state;
        return (
            <div className='market_us'>
                <div className='us_gainers'>
                    <div className='title'>{language.market_gainers}</div>
                    <DataTable showPagination = {false} columnDefs={columnDefs} data={data} innerRef={(e) => (this.GainersRef = e)} ></DataTable>
            </div>
                <div className='us_losers'>
                    <div className='title'>{language.market_losers}</div>
                    <DataTable showPagination = {false} columnDefs={columnDefs} data={data} innerRef={(e) => (this.LosersRef = e)}></DataTable>
                    </div>
            </div> 
        )
    }
    componentDidMount(){
      this.GainersRef.toggleLoadingOverlay(false)
      this.LosersRef.toggleLoadingOverlay(false)
    }
}



export default connect(
    (state) => ({
      language: state.app.language,
      user: state.auth.user,
      currentTradingAccount: state.trade.currentTradingAccount,
      markets: [
        { label: state.app.language.market_all, value: "" },
        ...state.trade.markets,
      ],
      isNeedRefresh: state.refresh.orderTable,
      theme: state.app.theme,
      mdsToken: state.trade.mdsToken,
    }),
    (dispatch) => ({
      getMarketActiveStocks: (p, c) =>dispatch(userActions.getHotTopInstrumentAction(p, c)),
      getDetailPriceInfo: (p, c) =>dispatch(stockActions.getDetailPriceInfoAction(p, c)),
      getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
    })
  )(Market_US);